import axios from "axios";
import { authService } from "./authService";
import { getApiBaseUrl } from "./apiBase";

const userApiService = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: false,
});

let refreshInFlight = null;

const isTokenError = (error) => {
  const status = error.response?.status;
  const message = String(
    error.response?.data?.message ||
    error.response?.data?.body?.message ||
    error.response?.data?.error ||
    ""
  );
  return (
    status === 401 ||
    (status === 403 && /token/i.test(message))
  );
};

const redirectToLogin = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("user");
  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
};

userApiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

userApiService.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config || {};
    if (!isTokenError(error) || original._retry) {
      return Promise.reject(error);
    }

    original._retry = true;
    try {
      if (!refreshInFlight) {
        refreshInFlight = authService.refreshToken().finally(() => {
          refreshInFlight = null;
        });
      }
      const result = await refreshInFlight;
      if (!result?.success || !result.accessToken) {
        redirectToLogin();
        return Promise.reject(error);
      }
      original.headers = original.headers || {};
      original.headers.Authorization = `Bearer ${result.accessToken}`;
      return userApiService(original);
    } catch (refreshError) {
      redirectToLogin();
      return Promise.reject(refreshError);
    }
  }
);

export default userApiService;
